import React, { useState} from 'react';
import './index.css';
import Header from './components/Header'
import Opening from './components/Opening'
import Masukan from './components/Masukan'
import Contactme from './components/Contactme';

function App() {
  const [showMasukan, setShowMasukan] = useState(true)
  const [showHeader, setShowHeader] = useState(false)
  const [showHome, setShowHome] = useState(false)
  const [showContact, setShowContact] = useState(false)
  const [name, setName] = useState("")
  
  const fungsiNama = (nama) => {
    console.log(nama);
    setName(nama)
  }
  
  const fungsiTampil = (nama) => {
    setShowMasukan(false);
    setShowHeader(true);
    setShowHome(true);
    fungsiNama(nama);
  }

  const tampilContact = () => {
    setShowHome(false);
    setShowContact(true);
  }

  const tampilHome = () => {
    setShowContact(false);
    setShowHome(true);
  }

  const tampilExperience = () => {
    alert("Under development")
  }
  
  

  return (
    <div>
      
      
        { showMasukan && 
        <Masukan onAdd={fungsiTampil} />
        }
      
      
      { showHeader && 
        <Header onContact={tampilContact} onHome={tampilHome} onExperience={tampilExperience}/>
        }

      { showHome && 
        <Opening nama={name.text} />
      }

      { showContact &&         
        <Contactme nama={name.text} /> 
      }


      
      
              
  </div>   

  );
}

export default App;
